import { useEffect, useRef, useState } from 'react';

export function useModalState(show, initialState) {
  const [state, setState] = useState(initialState);
  const showRef = useRef(show);
  useEffect(() => {
    if (showRef.current !== show) {
      if (showRef.current === false) {
        // reset the modal state when "show" changes from false to true
        setState(initialState);
      }
      showRef.current = show;
    }
  }, [show, initialState]);
  return [state, setState];
}
